import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import type { Engine, Container } from "@tsparticles/engine";
import { loadSlim } from "@tsparticles/slim";
import { tsParticles } from "@tsparticles/engine";
import { particlesConfig } from './particles.config';

@Component({
  selector: 'app-particles',
  standalone: true,
  imports: [],
  templateUrl: './particles.component.html',
  styleUrl: './particles.component.scss'
})
export class ParticlesComponent implements OnInit, AfterViewInit {
  @ViewChild('particlesContainer', { static: false }) particlesContainer!: ElementRef;
  id = "tsparticles";

  particlesOptions = particlesConfig;

  ngOnInit(): void {
    // console.log('Particles component initialized');
  }

  async ngAfterViewInit(): Promise<void> {
    // Inicializar el engine con loadSlim
    await loadSlim(tsParticles);
    
    // Cargar las partículas
    await tsParticles.load({
      id: this.id,
      options: this.particlesOptions as any
    });
  }
}

